import { Outlet, ScrollRestoration, useRouteLoaderData } from 'react-router';
import type { PortfolioSnapshot } from '@im-marina/shared';
import { ChromeProvider } from '../lib/chrome';
import { SnapshotContext } from '../lib/snapshot-context';
import { Header } from './Header/Header';
import { Footer } from './Footer/Footer';

export function Layout() {
  const snapshot = useRouteLoaderData('root') as PortfolioSnapshot;
  const { settings } = snapshot;
  return (
    <SnapshotContext value={snapshot}>
      <ChromeProvider>
        <Header title={settings.heroTitle} social={settings.social} />
        <Outlet />
        <Footer email={settings.contactEmail} social={settings.social} />
        {/* Fresh page loads all get the history key "default", which would make one page
          restore another's scroll position; fall back to the path for those. */}
        <ScrollRestoration getKey={(l) => (l.key === 'default' ? l.pathname : l.key)} />
      </ChromeProvider>
    </SnapshotContext>
  );
}
